import { Component, computed, inject, input } from "@angular/core";
import { IUnitShareInfo } from "../../models/unit-share-info.model";
import { EvGridTableModule, ITableLayoutModel, ITableHeader, BaseListComponent } from "ev-grid-table";
import { ThousandizePipe } from "ev-core";
import { DefaultConverterPipe } from "src/app/shared/pipes/defaultconverter.pipe";
import { InternalNavigationService } from "src/services/internal-navigation.service";

@Component({
    selector: "unit-shares",
    templateUrl: "./unit-shares.component.html",
    styleUrl: "./unit-shares.component.scss",
    imports: [ThousandizePipe, EvGridTableModule, DefaultConverterPipe],
})
export class UnitSharesComponent extends BaseListComponent<IUnitShareInfo> {
    navService = inject(InternalNavigationService);

    unitShares = input.required<IUnitShareInfo[]>();
    maxToShow = input<number>(50);
    originalData = computed(() => this.unitShares() || []);

    constructor() {
        super();
    }

    protected createHeaders(): ITableHeader[] {
        return [
            {
                name: "Type",
                prop: "estateType",
                desc: false,
                type: "text",
                isSortable: false,
            },
            {
                name: "Adresse",
                prop: "address",
                desc: false,
                type: "text",
                isSortable: true,
            },
            {
                name: "Kommune",
                prop: "municipalityName",
                desc: false,
                type: "text",
                isSortable: true,
            },
            {
                name: "Enhetsnummer",
                prop: "functionalUnitNumber",
                desc: false,
                type: "text",
                isSortable: true,
            },
            {
                name: "Etg",
                prop: "floor",
                desc: false,
                type: "text",
                isSortable: true,
            },
            {
                name: "m²",
                prop: "primaryArea",
                desc: false,
                type: "number",
                isSortable: true,
            },
            {
                name: "Pris eks fg",
                prop: "nodata",
                desc: false,
                type: "number",
                isSortable: false,
            },
            {
                name: "f.gjeld",
                prop: "nodata2",
                desc: false,
                type: "number",
                isSortable: true,
            },
            {
                name: "total",
                prop: "nodata3",
                desc: false,
                type: "number",
                isSortable: true,
            },
            {
                name: "Dato",
                prop: "nodata4",
                desc: false,
                type: "text",
                isSortable: true,
            },
        ];
    }

    navigate(unitId: number): void {
        this.navService.stockCooperativeShareInfopageUrl(unitId);
    }

    protected createDisplayTemplate(): ITableLayoutModel {
        return {
            breakPoints: [
                {
                    gridAreas:
                        '"spacingLeft estateType address nodata nodata4" "municipalityName municipalityName municipalityName municipalityName municipalityName" "functionalUnitNumber functionalUnitNumber functionalUnitNumber functionalUnitNumber functionalUnitNumber" "floor floor floor floor floor" "primaryArea primaryArea primaryArea primaryArea primaryArea" "nodata2 nodata2 nodata2 nodata2 nodata2" "nodata3 nodata3 nodata3" nodata3" nodata3"',
                    gridColumns: "50px 50px minmax(200px, 1fr) minmax(50px, 1fr) minmax(50px, 1fr)",
                    maxWidth: 767,
                },
                {
                    gridAreas:
                        '"spacingLeft estateType address municipalityName functionalUnitNumber floor" "primaryArea primaryArea primaryArea primaryArea primaryArea primaryArea" "nodata nodata nodata nodata nodata nodata" "nodata2 nodata2 nodata2 nodata2 nodata2 nodata2" "nodata3 nodata3 nodata3 nodata3 nodata3 nodata3" "nodata4 nodata4 nodata4 nodata4 nodata4 nodata4"',
                    gridColumns: "50px 50px minmax(250px, 1fr) minmax(120px, 1fr) minmax(80px, 1fr) minmax(50px, 1fr)",
                    maxWidth: 1179,
                },
                {
                    gridAreas: '"spacingLeft estateType address municipalityName functionalUnitNumber floor primaryArea nodata nodata2 nodata3 nodata4"',
                    gridColumns:
                        "50px 50px minmax(250px, 1fr) minmax(120px, 1fr) minmax(80px, 1fr) minmax(50px, 1fr) minmax(50px, 1fr)  minmax(50px, 1fr) minmax(50px, 1fr) minmax(50px, 1fr) minmax(50px, 1fr)",
                },
            ],
        };
    }

    protected lowercase(value: string): string {
        return value.toLowerCase();
    }
}
